import { useCallback, useEffect, useMemo, useState } from 'react';
import { useStoreActions } from '~/contexts';
import { useUploadLogo } from '~/hooks/useUploadLogo';
import { handleRequest } from '~/infra/utils';
import { makeDefaultBranding } from '~/store/store.utils';
export function useBrandStepForm(param) {
    let { worksAt } = param;
    const { api, setBranding } = useStoreActions();
    const { uploadLogo, savingLogo } = useUploadLogo(worksAt);
    const initialBranding = useMemo(()=>{
        var _ref;
        return (_ref = worksAt === null || worksAt === void 0 ? void 0 : worksAt.branding) !== null && _ref !== void 0 ? _ref : makeDefaultBranding();
    }, [
        worksAt === null || worksAt === void 0 ? void 0 : worksAt.branding
    ]);
    const initialLogo = useMemo(()=>{
        var _ref;
        return {
            file: null,
            asDataURL: (_ref = worksAt === null || worksAt === void 0 ? void 0 : worksAt.logoUrl) !== null && _ref !== void 0 ? _ref : null
        };
    }, [
        worksAt === null || worksAt === void 0 ? void 0 : worksAt.logoUrl
    ]);
    const [branding, setLocalBranding] = useState(initialBranding);
    const [logo, setLogo] = useState(initialLogo);
    const [saving, setSaving] = useState(false);
    useEffect(()=>{
        setLocalBranding(initialBranding);
    }, [
        initialBranding
    ]);
    useEffect(()=>{
        setLogo(initialLogo);
    }, [
        initialLogo
    ]);
    const brandingDirty = useMemo(()=>branding.buttonPrimary !== initialBranding.buttonPrimary || branding.backgroundGradientStart !== initialBranding.backgroundGradientStart || branding.backgroundGradientEnd !== initialBranding.backgroundGradientEnd || branding.backgroundStandard !== initialBranding.backgroundStandard, [
        branding,
        initialBranding
    ]);
    const logoDirty = logo.file != null;
    const isDirty = brandingDirty || logoDirty;
    const save = useCallback(async ()=>{
        if (!isDirty || !worksAt) return true;
        setSaving(true);
        try {
            if (logoDirty && logo.file && logo.asDataURL) {
                const { success } = await uploadLogo({
                    file: logo.file,
                    asDataURL: logo.asDataURL
                });
                if (!success) return false;
            }
            if (brandingDirty) {
                const { success } = await handleRequest(api.user.updateBranding(worksAt.id, branding));
                if (!success) return false;
                setBranding(branding);
            }
            return true;
        } finally{
            setSaving(false);
        }
    }, [
        isDirty,
        logoDirty,
        brandingDirty,
        logo,
        branding,
        uploadLogo,
        api,
        worksAt,
        setBranding
    ]);
    return {
        branding,
        setBranding: setLocalBranding,
        logo,
        setLogo,
        isDirty,
        save,
        saving: saving || savingLogo
    };
}
